var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPng(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 10.6091V32.3926C31.5 33.0076 31.0059 33.5 30.4036 33.5H9.27957C8.6773 33.5 8.18317 33.0076 8.18317 32.3926V3.60762C8.18317 2.99259 8.6774 2.5 9.27957 2.5H22.885L31.5 10.6091Z",
    fill: "white",
    stroke: "#A6A6A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36511 29.1231L7.68305 31.5307L7.66533 28.7529L4.36511 29.1231Z",
    fill: "#3E1C87"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89076 16.5986H25.3161C25.8075 16.5986 26.2069 17.0657 26.2069 17.6413V28.2085C26.2069 28.7838 25.8079 29.2512 25.3161 29.2512H4.89076C4.39934 29.2512 4 28.7842 4 28.2085V17.6413C4 17.0661 4.39898 16.5986 4.89076 16.5986Z",
    fill: "#613AB5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 10.3931V10.6416H24.0561C23.4498 10.6416 22.9578 10.1463 22.9578 9.5355V2H23.0832L32 10.3931Z",
    fill: "#A6A6A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5151 7.83984H10.202V9.15168H20.5151V7.83984Z",
    fill: "#E6E6E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5151 10.2217H10.202V11.5335H20.5151V10.2217Z",
    fill: "#E6E6E6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5151 12.6035H10.202V13.9154H20.5151V12.6035Z",
    fill: "#E6E6E6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50635 26V19.9902H8.86377C10.2292 19.9902 11.0137 20.8328 11.0137 22.0156C11.0137 23.2151 10.2168 24.041 8.83057 24.041H7.75146V26H6.50635ZM7.75146 23.0366H8.63135C9.37012 23.0366 9.7312 22.6216 9.72705 22.0156C9.7312 21.418 9.37012 21.0154 8.63135 21.0112H7.75146V23.0366ZM16.8159 19.9902V26H15.7368L13.0972 22.1816H13.0474V26H11.8022V19.9902H12.8979L15.521 23.8086H15.5791V19.9902H16.8159ZM21.8213 21.9243C21.6511 21.3599 21.1987 21.0154 20.543 21.0112C19.6133 21.0154 18.9824 21.7251 18.9824 22.9868C18.9824 24.2568 19.5925 24.9749 20.5513 24.979C21.4104 24.9749 21.9209 24.4893 21.9375 23.7339H20.6343V22.7959H23.1411V23.543C23.1411 25.1201 22.0579 26.083 20.543 26.083C18.8579 26.083 17.7124 24.9043 17.7124 23.0034C17.7124 21.0527 18.9326 19.9072 20.5181 19.9072C21.8752 19.9072 22.917 20.7415 23.083 21.9243H21.8213Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPng);
export default __webpack_public_path__ + "static/media/icon-png.c3989eaa0043564da849857d8e6468df.svg";
export { ForwardRef as ReactComponent };